/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Arrayscape Gaming Dashboard API
 * Comprehensive REST API for event management, business operations, and analytics
 * OpenAPI spec version: 1.0.0
 */

export type GetReportsIncomeBreakdownParamsBreakdownBy = typeof GetReportsIncomeBreakdownParamsBreakdownBy[keyof typeof GetReportsIncomeBreakdownParamsBreakdownBy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetReportsIncomeBreakdownParamsBreakdownBy = {
  GetReportsIncomeBreakdownParamsBreakdownByState: 'state',
  GetReportsIncomeBreakdownParamsBreakdownByProgramType: 'program_type',
  GetReportsIncomeBreakdownParamsBreakdownByProgram: 'program',
  GetReportsIncomeBreakdownParamsBreakdownByCustomer: 'customer',
  GetReportsIncomeBreakdownParamsBreakdownByItem: 'item',
} as const;
